// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/@storybook/builder-webpack5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/@storybook/builder-webpack5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#storybook-docs .sbdocs-content {
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',
    sans-serif;
  max-width: 1200px;
}

#storybook-docs h1.sbdocs-title {
  font-family: inherit;
  font-size: 44px;
  line-height: 60px;
  /* identical to box height, or 143% */
  font-weight: 900;
  letter-spacing: -0.04em;
  color: #000000;
  margin-top: 49px;
}

#storybook-docs details:not(.sbdocs-preview details) {
  position: relative;
  z-index: 99;
}

#storybook-docs .sbdocs p:not(.sbdocs-preview p) {
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',
    sans-serif;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: -0.01em;
  color: #000000;
  margin-top: 24px;
}

#storybook-docs .sbdocs-wrapper {
  background: white;
  min-height: auto;
}

#storybook-docs .sbdocs-img.featured-image {
  max-width: 100%;
  margin: 48px 0;
  display: block;
}

#storybook-docs .sbdocs-img {
  border-radius: 24px;
}

#storybook-docs .sbdocs hr:not(.sbdocs-preview hr) {
  margin: 48px 0;
  height: 0;
  border-top: 1px solid #ebebeb;
}

#storybook-docs .sbdocs h2:not(.sbdocs-preview h2) {
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',
    sans-serif;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: black;
  border-top: 1px solid #ebebeb;
  border-bottom: none;
  margin: 48px 0 15px 0;
  padding: 48px 0 0 0;
}

#storybook-docs .sbdocs h2 code:not(.sbdocs-preview h2 code) {
  border-radius: 4px;
  font-size: 20px;
}

#storybook-docs .sbdocs-h3 {
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',
    sans-serif;
  font-size: 18px;
  line-height: 24px;
  margin: 25px 0 0 0 !important;
  letter-spacing: -0.01em;
  color: #000000;
}

#storybook-docs .sbdocs-h3 code {
  border-radius: 3px;
  font-size: 16px;
}

/* Only apply to H3s inside of stories which have a parent with an ID */
#storybook-docs [id] > .sbdocs-h3:before {
  content: '';
  display: block;
  height: 40px;
  margin: -40px 0 0;
}

#storybook-docs .sbdocs li:not(.sbdocs-preview li) {
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',
    sans-serif;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: -0.01em;

  /* Neutrals / Web / Gray 200 #1B1A19 */
  color: #1b1a19;
  margin-top: 8px;
}

#storybook-docs .sbdocs ul:not(.sbdocs-preview ul) {
  margin: 12px 0;
}

#storybook-docs .sbdocs-ul li:not(.sbdocs-preview .sbdocs-ul li) {
  list-style: none;
  position: relative;
}

#storybook-docs .sbdocs-ul .sbdocs-li::before {
  position: absolute;
  content: '•';
  color: #8d8d8d;
  top: 0;
  left: -15px;
}

#storybook-docs .sbdocs-ol .sbdocs-li::marker {
  color: #8d8d8d;
}

#storybook-docs .sbdocs-preview {
  border-radius: 16px;
  background: var(--colorBrandBackgroundInverted, #fff);
  padding: 0;
  box-shadow: none;
  border: 1px solid var(--colorNeutralStroke1, #e1dfdd);
}

#storybook-docs .sbdocs .docs-story div[scale] {
  height: auto !important;
}

#storybook-docs .innerZoomElementWrapper {
  padding: 30px;
}

#storybook-docs .sbdocs-preview > .os-host {
  display: none;
}

#storybook-docs span + .sbdocs .docblock-argstable tbody tr td button {
  color: #0078d4;
  color: red;
}

#storybook-docs .docs-story + div {
  background: #11100f;
}

#storybook-docs .sbdocs-content > div:last-child {
  margin-bottom: 96px;
}

#storybook-docs .docs-story > div {
  padding: 0;
  background: none;
}

#storybook-docs .docs-story > div:last-child {
  right: 31px;
  border-radius: 24px;
}

.docs-story + div > div:last-child {
  background: #000000;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px 5px 0px 0px;
  right: 31px;
}

.docs-story + div > div:last-child > button {
  color: white;
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',
    sans-serif;
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  letter-spacing: -0.01em;
}

#storybook-docs a.sbdocs-a {
  color: #0078d4;
  text-decoration: underline;
}

/* Styles for Github-flavored Markdown tables */
#storybook-docs table:not(.docblock-argstable, .sbdocs-preview table) {
  margin: 16px 0px;
  font-size: 14px;
  line-height: 24px;
  padding: 0;
  border-collapse: collapse;
}
#storybook-docs table:not(.docblock-argstable, .sbdocs-preview table) tr {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

#storybook-docs table:not(.docblock-argstable, .sbdocs-preview table) th {
  font-weight: bold;
  color: rgb(51, 51, 51);
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 6px 13px;
}

#storybook-docs table:not(.docblock-argstable, .sbdocs-preview table) td {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 6px 13px;
}

/*  */
/* Args Table */
/*  */

#storybook-docs .docblock-argstable tbody {
  box-shadow: none;
  border-left: none;
  border-right: none;
}

#storybook-docs .docblock-argstable-head th {
  letter-spacing: -0.01em;
  color: black;
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',
    sans-serif;
  font-size: 16px;
  line-height: 150%;
  font-weight: 600;
}

#storybook-docs thead.docblock-argstable-head {
  border-bottom: 1px solid #edebe9;
}

#storybook-docs .docblock-argstable-body > tr > td:nth-child(4) {
  display: none;
}

#storybook-docs .docblock-argstable-head > tr > th:nth-child(4) {
  display: none;
}

#storybook-docs .docblock-argstable tbody tr {
  border: none;
}

#storybook-docs table.docblock-argstable tbody.docblock-argstable-body td,
#storybook-docs .docblock-argstable th {
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 16px;
}

#storybook-docs .docblock-argstable tbody tr td:nth-child(1) span {
  font-weight: normal;
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',
    sans-serif;
  font-size: 16px;
  line-height: 130%;
  letter-spacing: -0.01em;
  color: #616161;
}

#storybook-docs .docblock-argstable tbody tr td {
  vertical-align: top;
}

#storybook-docs .docblock-argstable-body > tr > td > div > div > button {
  color: #0078d4;
  line-height: 21px;
}

#storybook-docs code:not(.sbdocs-preview code),
#storybook-docs .docblock-argstable tbody tr td:nth-child(3) > div > span,
#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) > div:nth-child(2) span,
#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) > div:nth-child(1) > div > span,
#storybook-docs .css-16d4d7t {
  font-family: 'Cascadia Code', Menlo, 'Courier New', Courier, monospace;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  letter-spacing: -0.2px;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
}

#storybook-docs code.sbdocs-code,
#storybook-docs .sbdocs-p code,
#storybook-docs .sbdocs-li code,
#storybook-docs .docblock-argstable code,
#storybook-docs .docblock-argstable tbody tr td:nth-child(3) > div > span,
#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) > div:nth-child(2) span,
#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) > div:nth-child(1) > div > span,
#storybook-docs .css-16d4d7t {
  font-size: 14px;
  background: #f0f0f0;
  border-radius: 4px;
  padding: 1px 4px;
  margin: 0 3px 0 3px;
  color: black;
  border: none;
  line-height: 1.5;
}

#storybook-docs .docblock-argstable code {
  white-space: normal;
}

#storybook-docs code:not(.sbdocs-preview code) {
  padding: 0.1em 0.2em;
  display: inline-block;
  background-color: rgba(17, 16, 15, 0.1);
  border-radius: 2px;
}

.os-content-glue {
  width: auto !important;
}

#storybook-docs .sbdocs-preview .prismjs {
  overflow: hidden;
}

#storybook-docs .os-content .prismjs * {
  font-family: 'Cascadia Code', Menlo, 'Courier New', Courier, monospace;
  font-size: 14px;
  line-height: 1.4em;
}

#storybook-docs .sbdocs-preview .prismjs code {
  color: white;
  background: #11100f;
  margin: 0;
  overflow-x: auto;
}

#storybook-docs .docblock-argstable-body td > div > p,
#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) p,
#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) > div:nth-child(1) > span {
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',
    sans-serif;
  font-size: 16px;
  line-height: 130%;
  color: black;
  letter-spacing: -0.01em;
}

#storybook-docs .docblock-argstable tr > :nth-child(1) {
  width: 4%;
}

#storybook-docs .docblock-argstable tr > :nth-child(2) {
  width: 100%;
}

#storybook-docs .os-padding {
  z-index: 0;
}

@font-face {
  font-family: 'Segoe UI';
  src: local('Segoe UI Light'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/light/latest.woff2) format('woff2'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/light/latest.woff) format('woff'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/light/latest.ttf) format('truetype');
  font-weight: 100;
}

@font-face {
  font-family: 'Segoe UI';
  src: local('Segoe UI Semilight'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semilight/latest.woff2) format('woff2'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semilight/latest.woff) format('woff'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semilight/latest.ttf) format('truetype');
  font-weight: 200;
}

@font-face {
  font-family: 'Segoe UI';
  src: local('Segoe UI'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/normal/latest.woff2) format('woff2'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/normal/latest.woff) format('woff'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/normal/latest.ttf) format('truetype');
  font-weight: 400;
}

@font-face {
  font-family: 'Segoe UI';
  src: local('Segoe UI Semibold'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semibold/latest.woff2) format('woff2'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semibold/latest.woff) format('woff'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semibold/latest.ttf) format('truetype');
  font-weight: 600;
}

@font-face {
  font-family: 'Segoe UI';
  src: local('Segoe UI Bold'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/bold/latest.woff2) format('woff2'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/bold/latest.woff) format('woff'),
    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/bold/latest.ttf) format('truetype');
  font-weight: 700;
}

body,
body h1,
body h2,
body p,
body ul,
body ul li {
  font-family: 'Segoe UI' !important;
}

h1.fluent {
  font-weight: 700;
  font-size: 40px;
  font-family: 'Segoe UI';
  line-height: 60px;
  letter-spacing: -0.16px;
}

h1.fluent .fluent-version {
  display: block;
  font-size: 24px; /* --font-size-base-600 */
  line-height: 32px;
  color: #707070; /* --color-neutral-foreground-3 */
}

h2.fluent {
  font-weight: 600;
  font-size: 24px;
  font-family: 'Segoe UI';
  line-height: 36px;
  letter-spacing: -0.16px;
}
`, "",{"version":3,"sources":["webpack://./../../.storybook/docs-root.css"],"names":[],"mappings":"AAAA;EACE;cACY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;cACY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE;cACY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;cACY;EACZ,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;cACY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;;EAEvB,sCAAsC;EACtC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,MAAM;EACN,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qDAAqD;EACrD,UAAU;EACV,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ;cACY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA,KAAK;AACL,eAAe;AACf,KAAK;;AAEL;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ;cACY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB;cACY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;EAKE,sEAAsE;EACtE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;;;;;;;;EAQE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sEAAsE;EACtE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;EAGE;cACY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB;;;0GAGwG;EACxG,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB;;;8GAG4G;EAC5G,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB;;;2GAGyG;EACzG,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB;;;6GAG2G;EAC3G,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB;;;yGAGuG;EACvG,gBAAgB;AAClB;;AAEA;;;;;;EAME,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe,EAAE,yBAAyB;EAC1C,iBAAiB;EACjB,cAAc,EAAE,iCAAiC;AACnD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;AACzB","sourcesContent":["#storybook-docs .sbdocs-content {\n  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',\n    sans-serif;\n  max-width: 1200px;\n}\n\n#storybook-docs h1.sbdocs-title {\n  font-family: inherit;\n  font-size: 44px;\n  line-height: 60px;\n  /* identical to box height, or 143% */\n  font-weight: 900;\n  letter-spacing: -0.04em;\n  color: #000000;\n  margin-top: 49px;\n}\n\n#storybook-docs details:not(.sbdocs-preview details) {\n  position: relative;\n  z-index: 99;\n}\n\n#storybook-docs .sbdocs p:not(.sbdocs-preview p) {\n  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',\n    sans-serif;\n  font-size: 18px;\n  line-height: 27px;\n  letter-spacing: -0.01em;\n  color: #000000;\n  margin-top: 24px;\n}\n\n#storybook-docs .sbdocs-wrapper {\n  background: white;\n  min-height: auto;\n}\n\n#storybook-docs .sbdocs-img.featured-image {\n  max-width: 100%;\n  margin: 48px 0;\n  display: block;\n}\n\n#storybook-docs .sbdocs-img {\n  border-radius: 24px;\n}\n\n#storybook-docs .sbdocs hr:not(.sbdocs-preview hr) {\n  margin: 48px 0;\n  height: 0;\n  border-top: 1px solid #ebebeb;\n}\n\n#storybook-docs .sbdocs h2:not(.sbdocs-preview h2) {\n  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',\n    sans-serif;\n  font-size: 24px;\n  line-height: 28px;\n  letter-spacing: -0.04em;\n  color: black;\n  border-top: 1px solid #ebebeb;\n  border-bottom: none;\n  margin: 48px 0 15px 0;\n  padding: 48px 0 0 0;\n}\n\n#storybook-docs .sbdocs h2 code:not(.sbdocs-preview h2 code) {\n  border-radius: 4px;\n  font-size: 20px;\n}\n\n#storybook-docs .sbdocs-h3 {\n  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',\n    sans-serif;\n  font-size: 18px;\n  line-height: 24px;\n  margin: 25px 0 0 0 !important;\n  letter-spacing: -0.01em;\n  color: #000000;\n}\n\n#storybook-docs .sbdocs-h3 code {\n  border-radius: 3px;\n  font-size: 16px;\n}\n\n/* Only apply to H3s inside of stories which have a parent with an ID */\n#storybook-docs [id] > .sbdocs-h3:before {\n  content: '';\n  display: block;\n  height: 40px;\n  margin: -40px 0 0;\n}\n\n#storybook-docs .sbdocs li:not(.sbdocs-preview li) {\n  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',\n    sans-serif;\n  font-size: 16px;\n  line-height: 150%;\n  letter-spacing: -0.01em;\n\n  /* Neutrals / Web / Gray 200 #1B1A19 */\n  color: #1b1a19;\n  margin-top: 8px;\n}\n\n#storybook-docs .sbdocs ul:not(.sbdocs-preview ul) {\n  margin: 12px 0;\n}\n\n#storybook-docs .sbdocs-ul li:not(.sbdocs-preview .sbdocs-ul li) {\n  list-style: none;\n  position: relative;\n}\n\n#storybook-docs .sbdocs-ul .sbdocs-li::before {\n  position: absolute;\n  content: '•';\n  color: #8d8d8d;\n  top: 0;\n  left: -15px;\n}\n\n#storybook-docs .sbdocs-ol .sbdocs-li::marker {\n  color: #8d8d8d;\n}\n\n#storybook-docs .sbdocs-preview {\n  border-radius: 16px;\n  background: var(--colorBrandBackgroundInverted, #fff);\n  padding: 0;\n  box-shadow: none;\n  border: 1px solid var(--colorNeutralStroke1, #e1dfdd);\n}\n\n#storybook-docs .sbdocs .docs-story div[scale] {\n  height: auto !important;\n}\n\n#storybook-docs .innerZoomElementWrapper {\n  padding: 30px;\n}\n\n#storybook-docs .sbdocs-preview > .os-host {\n  display: none;\n}\n\n#storybook-docs span + .sbdocs .docblock-argstable tbody tr td button {\n  color: #0078d4;\n  color: red;\n}\n\n#storybook-docs .docs-story + div {\n  background: #11100f;\n}\n\n#storybook-docs .sbdocs-content > div:last-child {\n  margin-bottom: 96px;\n}\n\n#storybook-docs .docs-story > div {\n  padding: 0;\n  background: none;\n}\n\n#storybook-docs .docs-story > div:last-child {\n  right: 31px;\n  border-radius: 24px;\n}\n\n.docs-story + div > div:last-child {\n  background: #000000;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 5px 5px 0px 0px;\n  right: 31px;\n}\n\n.docs-story + div > div:last-child > button {\n  color: white;\n  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',\n    sans-serif;\n  font-size: 14px;\n  line-height: 150%;\n  text-align: center;\n  letter-spacing: -0.01em;\n}\n\n#storybook-docs a.sbdocs-a {\n  color: #0078d4;\n  text-decoration: underline;\n}\n\n/* Styles for Github-flavored Markdown tables */\n#storybook-docs table:not(.docblock-argstable, .sbdocs-preview table) {\n  margin: 16px 0px;\n  font-size: 14px;\n  line-height: 24px;\n  padding: 0;\n  border-collapse: collapse;\n}\n#storybook-docs table:not(.docblock-argstable, .sbdocs-preview table) tr {\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n#storybook-docs table:not(.docblock-argstable, .sbdocs-preview table) th {\n  font-weight: bold;\n  color: rgb(51, 51, 51);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 6px 13px;\n}\n\n#storybook-docs table:not(.docblock-argstable, .sbdocs-preview table) td {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 6px 13px;\n}\n\n/*  */\n/* Args Table */\n/*  */\n\n#storybook-docs .docblock-argstable tbody {\n  box-shadow: none;\n  border-left: none;\n  border-right: none;\n}\n\n#storybook-docs .docblock-argstable-head th {\n  letter-spacing: -0.01em;\n  color: black;\n  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',\n    sans-serif;\n  font-size: 16px;\n  line-height: 150%;\n  font-weight: 600;\n}\n\n#storybook-docs thead.docblock-argstable-head {\n  border-bottom: 1px solid #edebe9;\n}\n\n#storybook-docs .docblock-argstable-body > tr > td:nth-child(4) {\n  display: none;\n}\n\n#storybook-docs .docblock-argstable-head > tr > th:nth-child(4) {\n  display: none;\n}\n\n#storybook-docs .docblock-argstable tbody tr {\n  border: none;\n}\n\n#storybook-docs table.docblock-argstable tbody.docblock-argstable-body td,\n#storybook-docs .docblock-argstable th {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  padding-left: 16px;\n}\n\n#storybook-docs .docblock-argstable tbody tr td:nth-child(1) span {\n  font-weight: normal;\n  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',\n    sans-serif;\n  font-size: 16px;\n  line-height: 130%;\n  letter-spacing: -0.01em;\n  color: #616161;\n}\n\n#storybook-docs .docblock-argstable tbody tr td {\n  vertical-align: top;\n}\n\n#storybook-docs .docblock-argstable-body > tr > td > div > div > button {\n  color: #0078d4;\n  line-height: 21px;\n}\n\n#storybook-docs code:not(.sbdocs-preview code),\n#storybook-docs .docblock-argstable tbody tr td:nth-child(3) > div > span,\n#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) > div:nth-child(2) span,\n#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) > div:nth-child(1) > div > span,\n#storybook-docs .css-16d4d7t {\n  font-family: 'Cascadia Code', Menlo, 'Courier New', Courier, monospace;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 130%;\n  letter-spacing: -0.2px;\n  box-decoration-break: clone;\n  -webkit-box-decoration-break: clone;\n}\n\n#storybook-docs code.sbdocs-code,\n#storybook-docs .sbdocs-p code,\n#storybook-docs .sbdocs-li code,\n#storybook-docs .docblock-argstable code,\n#storybook-docs .docblock-argstable tbody tr td:nth-child(3) > div > span,\n#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) > div:nth-child(2) span,\n#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) > div:nth-child(1) > div > span,\n#storybook-docs .css-16d4d7t {\n  font-size: 14px;\n  background: #f0f0f0;\n  border-radius: 4px;\n  padding: 1px 4px;\n  margin: 0 3px 0 3px;\n  color: black;\n  border: none;\n  line-height: 1.5;\n}\n\n#storybook-docs .docblock-argstable code {\n  white-space: normal;\n}\n\n#storybook-docs code:not(.sbdocs-preview code) {\n  padding: 0.1em 0.2em;\n  display: inline-block;\n  background-color: rgba(17, 16, 15, 0.1);\n  border-radius: 2px;\n}\n\n.os-content-glue {\n  width: auto !important;\n}\n\n#storybook-docs .sbdocs-preview .prismjs {\n  overflow: hidden;\n}\n\n#storybook-docs .os-content .prismjs * {\n  font-family: 'Cascadia Code', Menlo, 'Courier New', Courier, monospace;\n  font-size: 14px;\n  line-height: 1.4em;\n}\n\n#storybook-docs .sbdocs-preview .prismjs code {\n  color: white;\n  background: #11100f;\n  margin: 0;\n  overflow-x: auto;\n}\n\n#storybook-docs .docblock-argstable-body td > div > p,\n#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) p,\n#storybook-docs .docblock-argstable-body > tr > td:nth-child(2) > div:nth-child(1) > span {\n  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',\n    sans-serif;\n  font-size: 16px;\n  line-height: 130%;\n  color: black;\n  letter-spacing: -0.01em;\n}\n\n#storybook-docs .docblock-argstable tr > :nth-child(1) {\n  width: 4%;\n}\n\n#storybook-docs .docblock-argstable tr > :nth-child(2) {\n  width: 100%;\n}\n\n#storybook-docs .os-padding {\n  z-index: 0;\n}\n\n@font-face {\n  font-family: 'Segoe UI';\n  src: local('Segoe UI Light'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/light/latest.woff2) format('woff2'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/light/latest.woff) format('woff'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/light/latest.ttf) format('truetype');\n  font-weight: 100;\n}\n\n@font-face {\n  font-family: 'Segoe UI';\n  src: local('Segoe UI Semilight'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semilight/latest.woff2) format('woff2'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semilight/latest.woff) format('woff'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semilight/latest.ttf) format('truetype');\n  font-weight: 200;\n}\n\n@font-face {\n  font-family: 'Segoe UI';\n  src: local('Segoe UI'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/normal/latest.woff2) format('woff2'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/normal/latest.woff) format('woff'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/normal/latest.ttf) format('truetype');\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'Segoe UI';\n  src: local('Segoe UI Semibold'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semibold/latest.woff2) format('woff2'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semibold/latest.woff) format('woff'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semibold/latest.ttf) format('truetype');\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: 'Segoe UI';\n  src: local('Segoe UI Bold'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/bold/latest.woff2) format('woff2'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/bold/latest.woff) format('woff'),\n    url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/bold/latest.ttf) format('truetype');\n  font-weight: 700;\n}\n\nbody,\nbody h1,\nbody h2,\nbody p,\nbody ul,\nbody ul li {\n  font-family: 'Segoe UI' !important;\n}\n\nh1.fluent {\n  font-weight: 700;\n  font-size: 40px;\n  font-family: 'Segoe UI';\n  line-height: 60px;\n  letter-spacing: -0.16px;\n}\n\nh1.fluent .fluent-version {\n  display: block;\n  font-size: 24px; /* --font-size-base-600 */\n  line-height: 32px;\n  color: #707070; /* --color-neutral-foreground-3 */\n}\n\nh2.fluent {\n  font-weight: 600;\n  font-size: 24px;\n  font-family: 'Segoe UI';\n  line-height: 36px;\n  letter-spacing: -0.16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
